import { useEffect, useState } from 'react';

import useGetCompanyInfo from 'stores/company/useGetCompanyInfo';
import { BestBidOffer } from '../../../../../../@types/orderbook';

const useBestBidOfferData = (
  data: BestBidOffer | null,
  symbol: string,
  defaultMarketStatus: string | null = null,
) => {
  const timeLeftSeconds = data?.time_left_seconds || 0;

  const [showBestBid, setShowBestBid] = useState<boolean>(false);
  const [bestBidData, setBestBidData] = useState<BestBidOffer | null>(data);
  const [isBlured, setIsBlured] = useState(false);

  const getCompanyInfo = useGetCompanyInfo((s) => s.getCompanyInfo);
  const companyData = useGetCompanyInfo((s) => s.data);

  useEffect(() => {
    if (symbol && !defaultMarketStatus) {
      getCompanyInfo(symbol);
    }
  }, [symbol, defaultMarketStatus]);

  // update data from websocket
  const setBestBidOffer = (newData: BestBidOfferResponse) => {
    const { bestBid, bestOffer } = newData;

    if (bestBid) {
      setBestBidData((prevData) => ({
        ...prevData,
        bid: bestBid,
      }));
    }

    if (bestOffer) {
      setBestBidData((prevData) => ({
        ...prevData,
        offer: bestOffer,
      }));
    }
  };

  useEffect(() => {
    if (data) {
      setBestBidData(data);
      setShowBestBid(true);
    }

    return () => {
      setShowBestBid(false);
    };
  }, [data]);

  useEffect(() => {
    const marketStatus = defaultMarketStatus || companyData[symbol]?.market_hour?.status;
    const hasBestBidOffer = data && showBestBid;

     if (marketStatus) {
      setIsBlured(marketStatus === 'open' && hasBestBidOffer);
    } else {
      setIsBlured(false);
    }

    return () => {
      setIsBlured(false);
    };
  }, [companyData, symbol, data, defaultMarketStatus, showBestBid]);

  useEffect(() => {
    let timeout: any = null;
    if (timeLeftSeconds > 0) {
      timeout = setTimeout(() => {
        setShowBestBid(false);
        setIsBlured(false);
      }, timeLeftSeconds * 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [timeLeftSeconds]);

  return { showBestBid, bestBidData, isBlured, setBestBidOffer };
};

export default useBestBidOfferData;
